import { render, staticRenderFns } from "./Direcciones.vue?vue&type=template&id=03215903&"
import script from "./Direcciones.vue?vue&type=script&lang=js&"
export * from "./Direcciones.vue?vue&type=script&lang=js&"
import style0 from "./Direcciones.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports